/* eslint-disable jsx-a11y/media-has-caption */
import { useParams } from 'react-router-dom';
import cam from '../../../../assets/images/cam.svg';
import icon from '../../../../assets/images/horizontal-white.png';
import Text from '../../../../assets/styles/Text';
import CustomMidia from '../../../../components/CustomMidia';
import Loader from '../../../../components/Loader';
import { useModelVerification } from '../../../../hooks/queries/useMediaUploads';
import { useModelFindAboutsSection } from '../../../../hooks/queries/useModels';
import formatFullDate from '../../../../utils/formatFullDate';
import * as styles from './styles';

export default function GroupAbout() {
  const { id } = useParams();

  const { data: aboutData, isLoading: isLoadingAbout } =
    useModelFindAboutsSection(id, 'ABOUT');

  const { data: treatmentData, isLoading: isLoadingTreatment } =
    useModelFindAboutsSection(id, 'TREATMENT');

  const { data: verification, isLoading: isLoadingVerification } =
    useModelVerification(id);

  const media = verification?.urls?.verificationMedia
    ? { url: verification.urls.verificationMedia, mediaType: 'video' }
    : null;
  const update = verification?.urls?.updateMedia;

  const loading = isLoadingAbout || isLoadingTreatment;

  function renderInfos(about, round = false) {
    const half = Math.ceil(about.length / 2);

    const contentHalf = round ? about.slice(0, half) : about.slice(half);

    const formatContent = (content) => content.replace(/,(?!\s)/g, ', ');

    return (
      <ul className={!round && 'this-list'}>
        {contentHalf.map((fil) => (
          <li key={fil.content}>
            <Text.Span>
              <b>{fil.name}:</b>
              {formatContent(fil.content)}
            </Text.Span>
          </li>
        ))}
      </ul>
    );
  }

  return (
    <styles.Container>
      <styles.GroupInfos>
        <styles.GroupUl>
          <Text.H3 $bold>Sobre mim:</Text.H3>
          <div>
            {loading ? (
              <Loader isLoading minimal />
            ) : (
              <>
                {renderInfos(aboutData, true)}
                {renderInfos(aboutData, false)}
              </>
            )}
          </div>
        </styles.GroupUl>

        <styles.GroupUl>
          <Text.H3 $bold>Atendimento:</Text.H3>
          <div>
            {loading ? (
              <Loader isLoading minimal />
            ) : (
              <>
                {renderInfos(treatmentData, true)}
                {renderInfos(treatmentData, false)}
              </>
            )}
          </div>
        </styles.GroupUl>
      </styles.GroupInfos>

      <styles.GroupCam className="desktop">
        <styles.TopCam>
          <styles.TextCam>
            <Text.H1>Não sou</Text.H1>
            <Text.H2>Fake!</Text.H2>
          </styles.TextCam>

          <styles.IconCam>
            <img src={cam} alt="camera" />

            <p>Vídeo de Comparação</p>
          </styles.IconCam>
        </styles.TopCam>

        <styles.VideoCam className="watermark">
          {isLoadingVerification ? (
            <Loader isLoading minimal />
          ) : (
            <CustomMidia midia={media} icon={false} index={999} isImg={false} />
          )}
        </styles.VideoCam>

        <styles.BottomCam>
          <Text.Span>ÚLTIMA VERIFICAÇÃO {formatFullDate(update)}</Text.Span>
          <img src={icon} alt="horizontal" />
        </styles.BottomCam>
      </styles.GroupCam>

      <div className="mobile">
        <styles.GroupCam>
          <styles.TopCam>
            <styles.TextCam>
              <Text.H1>Não sou</Text.H1>
              <Text.H2>Fake!</Text.H2>
            </styles.TextCam>

            <styles.IconCam>
              <img src={cam} alt="camera" />

              <p>Vídeo de Comparação</p>
            </styles.IconCam>
          </styles.TopCam>

          <styles.VideoCam className="watermark">
            <CustomMidia midia={media} icon={false} index={999} isImg={false} />
          </styles.VideoCam>

          <styles.BottomCam>
            <Text.Span>ÚLTIMA VERIFICAÇÃO {formatFullDate(update)}</Text.Span>
            <img src={icon} alt="horizontal" />
          </styles.BottomCam>
        </styles.GroupCam>
      </div>
    </styles.Container>
  );
}
